import React from "react";

const AdminLoading = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
      <p className="text-sm text-text-secondary">Loading...</p>
    </div>
  </div>
);

export default AdminLoading;
